import AccountService from '@/api-services/account.service';
import Session from '@/session';

// a vuex store module
export default {

	state: {
		loggingIn: false,
		registering: false,
		registerError: null,
		loginError: null,

		validation: {},

		auth: Session.getAuth(),
		userInfo: Session.getUserInfo()
	},

	mutations: {
		loginStart: state => state.loggingIn = true,

		loginStop: (state, errorMessage) => {
			state.loggingIn = false;
			state.loginError = errorMessage;
		},

		registerStart: state => state.registering = true,

		registerStop: (state, errorMessage) => {
			state.registering = false;
			state.registerError = errorMessage;
		},

		validate: (state, validationObject) => {
			state.validation = validationObject;
		},

		setAuthentication: (state, auth) => {
			state.auth = auth;
			Session.setAuth(auth);
		},

		setUserInfo: (state, userInfo) => {
			state.userInfo = userInfo;
			Session.setUserInfo(userInfo);
		},

		removeAuthentication: (state) => {
			state.auth = null;
			state.userInfo = null;
			Session.clear();
		}

	},

	actions: {
		// only vuex methods can call vuex mutations, and only they can affect vues states.
		// so if you want to do that from a vue, you need to pass through here, using ...mapactions to call the store methods directly.

		doLogin({ commit }, loginData) {

			commit('loginStart');

			AccountService.login(loginData).then(response => {

				commit('setAuthentication', response.data);

				commit('loginStop', null);

				AccountService.getUserInfo().then(response => {
					commit('setUserInfo', response.data);
				})
					.catch(error => {
						console.log(error);
					});

			}).catch(error => {
				commit('loginStop', error.response.data.error_description);
				commit('removeAuthentication');
			});
		},

		doLogout({ commit }) {
			AccountService.logout().then(() => {
				commit('removeAuthentication')
			})
				.catch(error => {
					console.log(error);
				});
		},

		getUserInfo({ commit }) {
			AccountService.getUserInfo().then(response => {
				commit('setUserInfo', response.data)
			})
				.catch(error => {
					console.log(error);
				});
		},

		getPing({ commit }) {
			AccountService.getPing().then(response => { })
				.catch((error) => {
					if (error.response) {
						if (error.response.status == 401) {
							commit('removeAuthentication');
						}
					}
				});
		},

		doRegister({ commit }, registerData) {
			commit('registerStart');

			// return the promise so we can wait around and log in afterwards
			return AccountService.register(registerData).then(response => {
				commit('registerStop', null);
			})
				.catch(error => {
					commit('registerStop', error.response.data.Message);
					commit('validate', error.response.data.ModelState);
				});
		}

	},

	getters: {
		getAuth(state) {
			return state.auth
		},
		isAuthenticated(state) {
			return state.auth !== null && typeof state.auth !== 'undefined'
		},
		userInfo(state) {
			return state.userInfo
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/account/index.js